import { styled, Theme, CSSObject } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';

const drawerWidth = 250;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden'
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`
});

const DrawerStyled = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '&& ::-webkit-scrollbar': { width: '6px' },
  '&& ::-webkit-scrollbar-thumb': {
    background: 'rgba(0,0,0,.3)',
    borderRadius: '19px'
  },
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  }),
  '& .MuiPaper-root': {
    top: 'inherit',
    borderRightWidth: 2,
    borderRightStyle: 'solid',
    borderRightColor: theme.palette.primary.main,
    '& .MuiListItemIcon-root': { minWidth: theme.spacing(5) },
    '& .MuiCollapse-root': { paddingLeft: theme.spacing(5) },
    paddingBottom: '100px'
  }
}));

export { DrawerStyled };
